import { useGetHolidaysDataQuery } from '../api/metricsApiSlice';

export const useHolidaysDatagridFetch = (
  _searchParams?: string
): ReturnType<typeof useGetHolidaysDataQuery> => {
  return useGetHolidaysDataQuery();
};
